import React from "react";
import NavBottomBar from "../../Components/Common/NavBottomBar";
import Calendar from "./calendar";
import MobileViewContainer from "../../Components/MobileViewContainer";

const ReservationPage = () => {
  return (
    <MobileViewContainer>
      <Calendar />

      <NavBottomBar activeBar={1} />
    </MobileViewContainer>
  );
};

export default ReservationPage;
